<template>
  <div class="msg-page">
    <!-- 弹幕层，铺满整页但不挡点击 -->
    <div class="msg-barrage">
      <vue-baberrage :barrageList="barrageList" :loop="true">
        <template v-slot:default="slotProps">
          <span class="msg-chip">
            <span class="msg-chip-head">
              <span class="msg-chip-fallback">
                {{ (slotProps.item.nickname || "客").charAt(0) }}
              </span>
              <img
                v-if="slotProps.item.avatar"
                class="msg-chip-avatar"
                :src="slotProps.item.avatar"
                @error="hideAvatar"
              />
            </span>
            <span class="msg-chip-name">{{ slotProps.item.nickname }}</span>
            <span class="msg-chip-text">{{ slotProps.item.content }}</span>
          </span>
        </template>
      </vue-baberrage>
    </div>
    <!-- 居中输入区 -->
    <div class="msg-center">
      <div class="sec-eyebrow">留言板</div>
      <h1 class="msg-title">路过，留句话再走</h1>
      <p class="msg-sub">
        无需登录。写下的留言会化作弹幕，与其他访客留下的一起，从这一页飘过。
      </p>
      <div class="msg-input-row">
        <input
          v-model="content"
          @keyup.enter="addToList"
          maxlength="60"
          placeholder="说点什么吧"
        />
        <button @click="addToList">发送</button>
      </div>
      <p class="msg-count" v-if="barrageList.length">
        已有 {{ barrageList.length }} 条留言在这页飘过
      </p>
    </div>
  </div>
</template>

<script>
import { listMessage, addMessage } from "../../api";
import { trackSiteEvent } from "@/utils/site-analytics";
export default {
  mounted() {
    this.listMessage();
  },
  data() {
    return {
      content: "",
      barrageList: []
    };
  },
  methods: {
    addToList() {
      if (this.content.trim() === "") {
        this.$toast({ type: "error", message: "留言不能为空" });
        return false;
      }
      const userAvatar = this.cleanAvatar(
        this.$store.state.avatar ||
          this.$store.state.blogInfo.webSite.touristAvatar
      );
      const userNickname = this.$store.state.nickname
        ? this.$store.state.nickname
        : "游客";
      var message = {
        avatar: userAvatar,
        status: 1,
        nickname: userNickname,
        content: this.content,
        time: 16 + Math.floor(Math.random() * 8)
      };
      this.barrageList.push(message);
      this.content = "";
      addMessage(message)
        .then(() => trackSiteEvent("message_submit", "message"))
        .catch(() => this.$toast({ type: "error", message: "留言未保存，请稍后重试" }));
    },
    listMessage() {
      listMessage().then(res => {
        res.data.forEach(m => {
          m.avatar = this.cleanAvatar(m.avatar);
          // 库里存的横穿时间偏快，统一放慢到 16-24 秒
          m.time = 16 + Math.floor(Math.random() * 8);
        });
        this.barrageList = res.data;
      });
    },
    // blogobs 域名已解析不了，头像挂那上面的一律当没有，退化成首字圆片
    cleanAvatar(url) {
      if (!url || url.indexOf("blogobs.88688.team") !== -1) return "";
      return url;
    },
    hideAvatar(e) {
      e.target.style.display = "none";
    }
  }
};
</script>

<style scoped>
.msg-page {
  position: relative;
  min-height: calc(100vh - 60px);
  overflow: hidden;
  background: var(--bg);
  /* 一点很淡的暖色光晕，免得整页太素 */
  background-image: radial-gradient(
      ellipse 720px 420px at 18% 20%,
      rgba(217, 119, 87, 0.07),
      transparent 70%
    ),
    radial-gradient(
      ellipse 640px 400px at 85% 78%,
      rgba(217, 119, 87, 0.05),
      transparent 70%
    );
}
.msg-center {
  position: relative;
  z-index: 5;
  max-width: 560px;
  margin: 0 auto;
  padding: 26vh 24px 0;
  text-align: center;
}
.msg-center .sec-eyebrow {
  letter-spacing: 3px;
}
.msg-title {
  font-size: 44px;
  line-height: 1.25;
  font-weight: 600;
  letter-spacing: -1px;
  color: var(--ink);
  margin: 0 0 18px;
}
.msg-sub {
  font-size: 15px;
  line-height: 2;
  color: var(--ink-soft);
  margin: 0 0 34px;
}
.msg-input-row {
  display: flex;
  gap: 10px;
  height: 52px;
}
.msg-input-row input {
  flex: 1;
  min-width: 0;
  outline: none;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: var(--bg-card);
  padding: 0 22px;
  font-size: 15px;
  color: var(--ink);
  box-shadow: 0 2px 10px rgba(20, 20, 19, 0.04);
  transition: border-color 0.2s;
}
.msg-input-row input::placeholder {
  color: var(--ink-faint);
}
.msg-input-row input:focus {
  border-color: var(--accent);
}
.msg-input-row button {
  outline: none;
  border: none;
  border-radius: 999px;
  padding: 0 30px;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  background: var(--accent);
  cursor: pointer;
  transition: background 0.2s;
}
.msg-input-row button:hover {
  background: var(--accent-deep);
}
.msg-count {
  margin-top: 20px;
  font-size: 13px;
  color: var(--ink-faint);
}
.msg-barrage {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  pointer-events: none;
}
.msg-chip {
  display: inline-flex;
  align-items: center;
  max-width: 460px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 5px 16px 5px 6px;
  box-shadow: 0 2px 10px rgba(20, 20, 19, 0.06);
}
.msg-chip-head {
  position: relative;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: var(--accent-wash);
}
.msg-chip-fallback {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: var(--accent-deep);
}
.msg-chip-avatar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.msg-chip-name {
  margin: 0 6px 0 8px;
  font-size: 13px;
  color: var(--ink-faint);
  white-space: nowrap;
}
.msg-chip-text {
  font-size: 14px;
  color: var(--ink-mid);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 760px) {
  .msg-center {
    padding-top: 20vh;
  }
  .msg-title {
    font-size: 32px;
  }
  .msg-chip {
    max-width: 320px;
  }
}
</style>
